import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
var _jsxFileName = "/home/christian/DEV/workspace/crossbuilders/form-library/src/lib/components/fields/Textarea/index.jsx";
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';
import FormHint from '../../structure/FormHint';
import '../../../assets/scss/3_components/_form-element.scss';
import Label from '../../structure/Label';
import FormRow from '../../structure/FormRow';
import { inputPropTypes, inputDefaultProps } from '../../../commonProps';
import useDebounce from '../../../hooks/useDebounce';
function TextareaComponent(props) {
  var id = props.id,
    name = props.name,
    inputRef = props.inputRef,
    value = props.value,
    onChange = props.onChange,
    onBlur = props.onBlur,
    children = props.children,
    placeholder = props.placeholder,
    labelClass = props.labelClass,
    inputClass = props.inputClass,
    errorClass = props.errorClass,
    rowClass = props.rowClass,
    disabled = props.disabled,
    readOnly = props.readOnly,
    required = props.required,
    maxLength = props.maxLength,
    errors = props.errors,
    delay = props.delay,
    warning = props.warning,
    info = props.info;
  var _useState = useState(value),
    _useState2 = _slicedToArray(_useState, 2),
    inputValue = _useState2[0],
    setInputValue = _useState2[1];
  var hasErrors = errors && Object.hasOwnProperty.call(errors, name);
  var errorMessage = hasErrors ? errors[name].message : null;
  var inputClassName = hasErrors ? "".concat(inputClass, " ").concat(errorClass) : inputClass;
  var debouncedInputValue = useDebounce(inputValue, delay);
  useEffect(function () {
    onChange(debouncedInputValue);
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [debouncedInputValue]);
  useEffect(function () {
    setInputValue(value);
  }, [value]);
  return /*#__PURE__*/React.createElement(FormRow, {
    className: rowClass,
    hasErrors: hasErrors,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 53,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Label, {
    id: id,
    className: labelClass,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 54,
      columnNumber: 13
    }
  }, children), /*#__PURE__*/React.createElement("textarea", {
    ref: inputRef,
    id: id,
    name: name,
    placeholder: placeholder,
    className: inputClassName,
    value: inputValue,
    onBlur: onBlur,
    onChange: function onChange(event) {
      return setInputValue(event.target.value);
    },
    disabled: disabled,
    readOnly: readOnly,
    required: required,
    maxLength: maxLength,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 56,
      columnNumber: 13
    }
  }), /*#__PURE__*/React.createElement(FormHint, {
    error: errorMessage,
    warning: warning,
    info: info,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 71,
      columnNumber: 13
    }
  }));
}
export default function Textarea(props) {
  var _this = this;
  return /*#__PURE__*/React.createElement(Controller, Object.assign({
    defaultValue: ""
  }, props, {
    render: function render(_ref) {
      var onChange = _ref.onChange,
        onBlur = _ref.onBlur,
        value = _ref.value;
      return /*#__PURE__*/React.createElement(TextareaComponent, Object.assign({}, props, {
        onChange: onChange,
        onBlur: onBlur,
        value: value || '',
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 83,
          columnNumber: 13
        }
      }));
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 82,
      columnNumber: 9
    }
  }));
}
Textarea.propTypes = _objectSpread(_objectSpread({}, inputPropTypes), {}, {
  delay: PropTypes.number
});
Textarea.defaultProps = _objectSpread(_objectSpread({}, inputDefaultProps), {}, {
  inputClass: 'form-element form-element--textarea',
  delay: 500
});